import Vue from 'vue'

import VueJsonp from 'vue-jsonp'
Vue.use(VueJsonp)
import router from './router'
import store from './store'
import App from '../src/App'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

import BaiduMap from 'vue-baidu-map'

Vue.use(BaiduMap, { ak: 'BhRnGMGCyEW1NzFxqUoGlPgIszhXOAYT' })

Vue.config.productionTip = false

//在vue中使用elementui
Vue.use(ElementUI)
new Vue({
    render: h => h(App),
    router,
    store
}).$mount('#app')


// WEBPACK FOOTER //
// ./src/main.js